import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import ThumbIconButton from '@wix/da-ds/pkg/thumbs/ThumbIconButton';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import CommentOutlineIcon from '@wix/da-ds/pkg/Icons/24x24/CommentOutline';
import { BiData, BiContextProvidedValue } from '@wix/da-bi/pkg/events';
import { getDeviationResourceType } from '../../../../_helpers';
import noop from '../../../../../utils/noop';
import { useSubscriptionTier } from '../../../../../utils/hooks/useSubscriptionTier';
import { useDeviationAttributes } from '../../../../hooks/useDeviationAttributes';
import SubscribeToUnlockTooltip from '../../../../../ActionBar/_partials/SubscribeToUnlockTooltip';
const CommentControl = ({ deviation, className, iconClassName, textClassName, disabledClassName, onClick = noop })=>{
    var _deviation_author;
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    const { isOwner, needsSubscription, isSubscribedButBlocked } = useSubscriptionTier(deviation);
    const { isCommentable } = useDeviationAttributes(deviation, isOwner);
    if (!isCommentable) {
        return null;
    }
    var _deviation_author_useridUuid;
    const biData = BiData({
        evid: 105,
        typeid: getDeviationResourceType(deviation),
        itemid: deviation.deviationId,
        creatorid: (_deviation_author_useridUuid = (_deviation_author = deviation.author) === null || _deviation_author === void 0 ? void 0 : _deviation_author.useridUuid) !== null && _deviation_author_useridUuid !== void 0 ? _deviation_author_useridUuid : '',
        sectionname: BiContextProvidedValue,
        sectionid: BiContextProvidedValue,
        section_typeid: BiContextProvidedValue,
        sectiontype: BiContextProvidedValue,
        sectionrank: BiContextProvidedValue,
        rank: BiContextProvidedValue,
        sort_type: BiContextProvidedValue,
        reason_shown: BiContextProvidedValue,
        widgetname: BiContextProvidedValue
    });
    const actionBlockedBySubscription = needsSubscription || isSubscribedButBlocked;
    if (isMobile) {
        var _deviation_stats;
        return /*#__PURE__*/ React.createElement(ThumbIconButton, {
            type: "comment",
            statValue: (_deviation_stats = deviation.stats) === null || _deviation_stats === void 0 ? void 0 : _deviation_stats.comments,
            onClick: actionBlockedBySubscription ? undefined : onClick,
            biData: biData
        });
    }
    return /*#__PURE__*/ React.createElement(SubscribeToUnlockTooltip, {
        deviation: deviation
    }, /*#__PURE__*/ React.createElement(TextButton, {
        className: classnames(actionBlockedBySubscription && disabledClassName, className),
        size: "medium",
        variant: "main",
        onClick: actionBlockedBySubscription ? undefined : onClick,
        disabled: actionBlockedBySubscription,
        biData: biData
    }, /*#__PURE__*/ React.createElement(CommentOutlineIcon, {
        className: iconClassName,
        size: IconSize.MEDIUM,
        disableDefaultColors: true
    }), /*#__PURE__*/ React.createElement("span", {
        className: textClassName
    }, t('actionbar.comment'))));
};
CommentControl.displayName = 'CommentControl';
export default CommentControl;

//# sourceMappingURL=CommentControl.js.map